import * as React from 'react';

// AI-Generated Documentation - Please Read with Caution

type Props = {
  /** Title text or element displayed at the top of the card */
  title: string | JSX.Element;
  /** Placeholder text for the filter input field */
  filterPlaceholder?: string;
  /** Current value of the filter input field */
  filter?: string;
  /** Callback function triggered when filter value changes */
  onFilterChange?: (value: string) => void;
  /** Main content to display in the card body */
  children?: JSX.Element;
  /** Optional elements to render below the filter input */
  filterChildren?: JSX.Element;
};

/** A card component for displaying data with an optional filter input. */
class DataCard extends React.Component<Props> {
  onFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (this.props.onFilterChange) {
      this.props.onFilterChange(e.target.value);
    }
  };

  render() {
    return (
      <div className="card" style={{ minHeight: 300, margin: 20, padding: 15 }}>
        <div style={{ display: 'flex', marginBottom: 10 }}>
          <div style={{ flex: 1 }}>
            <h3 className="table-title" style={{ padding: 20 }}>
              {this.props.title}
            </h3>
          </div>
          {this.props.filterPlaceholder && (
            <div style={{ flex: 1 }}>
              <div style={{ padding: '10px 20px' }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder={this.props.filterPlaceholder}
                  onChange={this.onFilterChange}
                  value={this.props.filter}
                />
                {this.props.filterChildren}
              </div>
            </div>
          )}
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default DataCard;
